import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';
import Loader from "@/components/Loader/LoaderView";

const domain=window.location.hostname;

export default {
  components: {
    Loader,
  },
  mounted() {
    this.fetch_users();
    this.token_exists = get_token();
    this.fetchPortalMembers();
    this.user_details=get_user_details();

    this.fetch_all_Portal_admin();
    this.$emit("update_portal_count", this.portal_member_count);
    if (domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if (domain.includes('workstreams') || domain.includes('demo')){
      this.stagging_domain = true;
    }
    this.fetch_Portal_admin();
    window.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    window.removeEventListener('click', this.handleClickOutside);
  },

  props: {
    topics: {
      type: Array,
      required: true
    },
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: ''
    },
  },

  watch: {
    '$route.params.portal_id': {
      handler(newPortalId) {
        this.portal_id = newPortalId;
        this.members = [];
        this.portal_creater = null;
        this.fetchPortalMembers();
      },
      immediate: true
    },
  },

  data() {
    return ({
      portals: [],
      members: [],
      users:[],
      selectedUserIds:[],
      portal_id:'',
      is_public: true,
      isLoading: false,
      is_loading: false,
      loading: true,
      token_exists: false,
      isSubmitting: false,
      errors: {},
      portal_creater:'',
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      portal_users:[],
      portals_roles:[],
      status:"",
      workbook_domain: false,
      stagging_domain: false,
      portal_admin_button:false,
      adminUserIds: new Set(),
      searchQuery: [],
      searchVisible: false,
      activeSearchFilter: null,
      appliedFilters: [],
      filterOptions: [
        { key: 'name', label: 'Name' },
        { key: 'location', label: 'Location' },
        { key: 'skills', label: 'Skills' },
        { key: 'education', label: 'Education' },
        { key: 'position', label: 'Position' }
      ],
      active_tab:'normal_loans_info',
      filteredMembers: [],
      selectAllMembers: false,
      searchValue: "",
    });
  },

  computed: {

    portal_id(){
      return this.$route.params.portal_id;
    },
    portal_member_count() {
      return this.members.length;
    },
    filteredUsers() {
      const query = String(this.searchQuery || '').toLowerCase();
      return this.users.filter(user =>
        user.first_name?.toLowerCase().includes(query) ||
        user.last_name?.toLowerCase().includes(query)
      );
    },
    filteredPortalUsers() {
      if(this.is_loading) return [];
      let filteredMembers = this.portal_users || [];
      this.appliedFilters.forEach((filter) => {
        if (filter.value) {
          filteredMembers = filteredMembers.filter((member) => {
            if (filter.key === 'name') {
              return this.filterByName(member, filter.value);
            } else if (filter.key === 'location') {
              return this.filterByLocation(member, filter.value);
            } else if (filter.key === 'skills') {
              return this.filterBySkills(member, filter.value);
            } else if (filter.key === 'education') {
              return this.filterByEducation(member, filter.value);
            } else if (filter.key === 'position') {
              return this.filterByPosition(member, filter.value);
            } else {
              return true; // Default fallback
            }
          });
        }
      });

      return filteredMembers;
    },

    areAllSelected() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    SelectAllMembers() {
      const filteredIds = this.filteredMembers.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    }
  },

  methods: {
    getToken() {
      return get_token();
            },
      fetchPortalMembers() {
  this.members = [];
  this.portal_creater = null;

  if (!this.portal_id) return;

  this.is_loading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
    method: "GET",
    data: { portal_id: this.portal_id },
    headers: {
      "Authorization": `Token ${this.getToken()}`,
      "Content-Type": "application/json"
    },
    success: (response) => {
      if (response.status === "success") {
        this.members = response.data.members;
      }
    },
    error: (xhr) => {
      console.error("Error fetching portal members:", xhr);
    },
    complete: async () => {
      // Wait for fetchUsersWithRoles to finish
      await new Promise((resolve) => {
        this.fetchUsersWithRoles(resolve);
      });
    }
  });
},

      get_user_id() {
        const user_id = localStorage.getItem('user_id') || '';
        return user_id;
    },

    selectFilter(filter) {
      if (!this.appliedFilters.includes(filter)) {
        this.appliedFilters.push(filter);
      }
    },

    toggleSearchInput(filter) {
      this.activeSearchFilter = this.activeSearchFilter === filter.key ? null : filter.key;
    },

    applyFilter(filter) {
      const filterOption = this.filterOptions.find(f => f.key === filter.key);
      const queryValue = this.searchQuery[filter.key];

      if (filterOption && queryValue !== undefined) {
        const appliedFilter = this.appliedFilters.find(f => f.key === filterOption.key);
        if (appliedFilter) {
          appliedFilter.value = queryValue || "";
        } else {
          this.appliedFilters.push({ key: filterOption.key, value: queryValue || "" });
        }
      }
      this.activeSearchFilter = null;
    },

    removeFilter(filter) {
      const index = this.appliedFilters.indexOf(filter);
      if (index !== -1) {
        this.appliedFilters.splice(index, 1);

        this.searchQuery.splice(index, 1);
        this.searchVisible = false;
      }
    },

    filterByName(member, value) {
      return (
        member.first_name.toLowerCase().includes(value.toLowerCase()) ||
        member.last_name.toLowerCase().includes(value.toLowerCase())
      );
    },
    filterByRole(member, value) {
      return (
        member.role.role.toLowerCase().includes(value.toLowerCase())
      );
    },
    searchMember(){

      if (this.searchValue.trim()!=""){
        this.portal_users = this.filteredMembers.filter((member) => (
        this.filterByRole(member, this.searchValue)||
        this.filterByName(member, this.searchValue)||
        this.filterByPosition(member, this.searchValue)) )
        return
      }
      this.portal_users =this.filteredMembers
    },

  filterByLocation(member, value) {
      const town = member.town?.toLowerCase() || '';
      const province = member.province?.toLowerCase() || '';
      const street = member.street_address?.toLowerCase() || '';
      return (
        town.includes(value.toLowerCase()) ||
        province.includes(value.toLowerCase()) ||
        street.includes(value.toLowerCase())
      );
    },

    filterBySkills(member, value) {
      return member.skills.some((skill) =>
        skill.toLowerCase().includes(value.toLowerCase())
      );
    },
    filterByEducation(member, value) {
      return member.education.toLowerCase().includes(value.toLowerCase());
    },

    filterByPosition(member, value) {
      return member.positions.some((position) =>
        position.portal_position.position.name.toLowerCase().includes(value.toLowerCase())
      );
    },

  getProfileLink(member) {
    // Check if the user is an admin
    if (member.role.role === 'admin') {
      window.location=`/profile?user_id=${member.user_id}`;
      return ``;
    } else if (member.role.role === 'user') {
      // Return the link for customer profiles
        window.location=`/profile?user_id=${member.user_id}`;
    } else {
      // Return a default profile link for other roles
      return ``;
    }
  },

  handleTopicClick(topicId) {
    this.$emit('topic_selected', topicId);
  },
  toggleSelectAll() {
    const filteredIds = this.filteredUsers.map(user => user.id);
    if (this.areAllSelected) {

      this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
    } else {
      this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
    }
  },
  toggleSelectAllMembers() {
    const filteredIds = this.filteredPortalUsers.map(user => user.id);
    if (this.SelectAllMembers) {
      this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
    } else {
      this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
    }
  },

  //   fetchPortals() {
  //     this.isLoading = true;
  //     this.portal_id=this.$route.params.portal_id
  //     $.ajax({
  //     url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
  //     method: 'POST',
  //     headers: {
  //         'Authorization': `Token ${this.getToken()}`,
  //         'Content-Type': 'application/json'
  //     },
  //     success: (data) => {
  //         this.portals = data.portals;
  //         const visible=this.portals.find(portal_id => portal_id.id === parseInt(this.portal_id, 10));
  //         if (visible) {
  //           this.is_public = visible.is_public;
  //         }
  //     },
  //     complete: () => {
  //         this.isLoading = false;
  //     }
  //     });
  // },

async fetch_users() {
  // alert("Here")
  try {
    const response = await fetch(
      `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    this.users = data.data.users_list.filter((user) => {
      const isAdmin = user.role?.role?.toLowerCase() === 'admin' || this.adminUserIds?.has(user.id);
      const isMember = this.members.some(member => member.user?.id === user.id);
      const isActive = user.is_active;
      return !isAdmin && !isMember && isActive;
    });

    this.$nextTick(() => {
      if ($.fn.DataTable.isDataTable('#addPortalMemberTable')) {
        $('#addPortalMemberTable').DataTable().destroy();
      }
      $('#addPortalMemberTable').DataTable({
        paging: true,
        searching: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available",
          search: "Search:"
        }
      });
    });

  } catch (error) {
    console.error('Failed to fetch users:', error);
  }
},
  addPortalMembers() {
    const baseUrl = `${window.location.origin}${this.$route.path}`
    if (this.selectedUserIds.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Please select at least one  user.',
        showConfirmButton: true
      });
      return;
    }
    this.isSubmitting = true;
    const requestData = {
      portal_id: this.$route.params.portal_id,
      user_id: this.selectedUserIds,
      base_url: baseUrl
    };
    $.ajax({
      method: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_portal_members/`,
      contentType: "application/json",
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(requestData),
      success: (response) => {
        const status = response.status;
        const newMembers = response.members.map(member => member.user);

        if (status === "success") {
          Swal.fire({
            icon: 'success',
            title: 'Members Added Successfully',
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {
            newMembers.forEach(user => {
              this.members.push(user);
              this.portal_users.push({
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                role: user.role,
                positions: []
              });
            });
            this.users = this.users.filter(user => !this.selectedUserIds.includes(user.id));
            this.selectedUserIds = [];
            $('#add_portal_member_modal').modal('hide');
            this.searchQuery = "";
            this.filteredMembers = this.portal_users
          });
        }
      },
      complete: () => {
        this.isSubmitting = false;
      }
    });
  },
  deletePortalMembers() {
    if (this.selectedUserIds.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Please select at least one user to remove.',
        showConfirmButton: true
      });
      return;
    }
    this.isSubmitting = true;
    const requestData = {
      portal_id: this.$route.params.portal_id,
      user_id: this.selectedUserIds,
    };
    $.ajax({
      method: "DELETE",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_portal_members/`,
      contentType: "application/json",
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(requestData),
      success: (response) => {
        if (response.status === "success") {
          Swal.fire({
            icon: 'success',
            title: 'Members Removed Successfully',
            showConfirmButton: false,
            timer: 1000,
            position: 'bottom-end',
            toast: true
          }).then(() => {

            this.selectedUserIds.forEach(userId => {
              const removed = this.members.find(member => member.id === userId);
              if (removed && !this.users.find(u => u.id === userId)) {
                this.users.push(removed);
              }
            });
            this.members = this.members.filter(member => !this.selectedUserIds.includes(member.id));
            this.portal_users = this.portal_users.filter(user => !this.selectedUserIds.includes(user.id));
            this.selectedUserIds = [];
            this.searchQuery = "";
            this.selectAllMembers = false;
            this.filteredMembers = this.portal_users
            $('#delete_portal_member_modal').modal('hide');
          });
        }
      },
      complete: () => {
        this.isSubmitting = false;
      }
    });
  },
  fetchPositionsAssigned(portal_id) {
    const payload = {
      filter_values: {
        id: portal_id
      }
    }
    $.ajax({
      type: "POST",
      url: process.env.VUE_APP_BACKEND_API_URL + "/portal_management/get_portal_assigned_position_api/",
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      data: JSON.stringify(payload),
      success: (response) => {
        if (response.status === "success") {
          this.portals_roles = response.portal_positions;
        }
      },
    });
  },
  assign_position_to_portal_user(event, portal_id,user_id) {

      const position_id = event.target.value;
      const payload = {
        user_id: user_id,
        position_id: position_id,
        portal_id: portal_id
      };

        $.ajax({
          type: "POST",
          url: process.env.VUE_APP_BACKEND_API_URL + "/portal_management/assign_roles_to_user_api/",
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          data: JSON.stringify(payload),
          success: (response) => {
            if (response.status === "success") {
              event.target.value = "";
              const user =this.portal_users.find(user => user.user_id === user_id);
              if (user) {
                user.positions.push({
                  position_id: position_id,
                  position_name: response.portal_positions[0].portal_position_name
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Failed to assign position.",
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          },
        });
      },
 fetchUsersWithRoles(done) {
  const payload = { portal_id: this.portal_id };

  $.ajax({
    type: "POST",
    url: process.env.VUE_APP_BACKEND_API_URL + "/portal_management/get_assigned_users_roles_api/",
    headers: {
      Authorization: `Token ${this.getToken()}`,
      "Content-Type": "application/json"
    },
    data: JSON.stringify(payload),
    success: (response) => {
      if (response.status === "success") {
        const userMap = new Map();

    response.portal_positions.forEach(item => {
      const user = item.portal_access?.user;
      const position = item.portal_position?.position;

      // Use short-circuiting: if user or id is missing, the rest of the line is ignored
      user && user.id && (() => {
        if (!userMap.has(user.id)) {
          userMap.set(user.id, {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            positions: []
          });
        }

        // Push position details if position exists
        if (position) {
          userMap.get(user.id).positions.push({
            position_id: position.id,
            position_name: position.name
                });
              }
            });
          });

          this.members.forEach(member => {
            if (!userMap.has(member.id)) {
              userMap.set(member.id, {
                id: member.id,
                first_name: member.first_name,
                last_name: member.last_name,
                email: member.email,
                role: member.role,
                positions: []
              });
            }
          });

          this.portal_users = Array.from(userMap.values())
            .filter(user => this.members.some(member => member.id === user.id))
            .map(user => {
              const matchingMember = this.members.find(member => member.id === user.id);
              return this.mergeUserAndMember(user, matchingMember);
            });
        this.filteredMembers = this.portal_users

        this.$nextTick(() => {
          if ($.fn.DataTable.isDataTable('#portalMemberTable')) {
            $('#portalMemberTable').DataTable().destroy();
          }
          $('#portalMemberTable').DataTable({
            paging: true,
            searching: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available",
              search: "Search:" // Matches your existing UI intent
            }
          });
        });

      }
    },
    complete: () => {
      this.is_loading = false; // ✅ only now
      if (done) done();
    }
  });
}
,
      getMergedValue(memberValue, userValue, defaultValue) {
        return memberValue ?? userValue ?? defaultValue;
      },
      get_member_profile_picture(member) {
        if (!member) return null;
        if (member.profile_picture) return member.profile_picture;
        if (member.user?.profile_picture) return member.user.profile_picture;

        const profileFiles = member.user?.profile?.profile_files || member.profile?.profile_files || [];
        const profilePicture = profileFiles.find(file => file.profile_file_type === 'profile_picture');
        return profilePicture?.file?.s3_url || profilePicture?.file?.url || profilePicture?.url || null;
      },
      mergeUserAndMember(user, member) {
        var object = {
          ...user,
          user_id:this.getMergedValue(member?.user?.id),
          full_name:this.getMergedValue(member?.full_name),
          first_name:this.getMergedValue(member?.user?.first_name),
          last_name:this.getMergedValue(member?.user?.last_name),
          email:this.getMergedValue(member?.user?.email, user.email, user.email),
          role: this.getMergedValue(member?.user?.role, user.role, user.role),
          positions:this.getMergedValue(member?.user_portal_positions, user.positions, user.positions),
          profile_picture: this.getMergedValue(member?.user?.profile_picture, user.profile_picture, user.profile_picture),
          profile: this.getMergedValue(member?.user?.profile, user.profile, user.profile),
        };
        return object;
      },
      remove_position(user_id, position_id, posIndex, portal_id) {
        const data = {
          user_id: user_id,
          portal_id: portal_id,
          position_id: position_id,
        };

        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_user_assign_role_api/`,
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(data),
          dataType: "json",
          success: (response_data) => {
            if (response_data.status === "success") {
              this.portal_users = this.portal_users.map(user => {
                if (user.id === user_id) {
                  user.positions = user.positions.filter((_, index) => index !== posIndex);
                }
                return user;
              });

            } else {
              Swal.fire({
                icon: 'error',
                title: 'Can not delete assigned position.',
                text: 'Please try again',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          }
        });
      },
      available_positions(portal, user) {
        const filtered_positions = portal.positions.filter(p =>
          !user.positions.some(up => String(up.position_id) === String(p.id))
        );
        return filtered_positions;
      },
      assign_portal_admin(user_id) {
        const portal_id = this.$route.params.portal_id;
        const base_url = `${window.location.origin}${this.$route.path}`;

        const payload = {
          user_id: user_id,
          portal_id: portal_id,
          base_url: base_url
        };


        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_plartform_admin_api/`,
          method: 'POST',
          data: JSON.stringify(payload),
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json',
          },
          success: (data) => {
            if (data.status === 'success') {
              this.fetch_all_Portal_admin()
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Portal Admin assigned successfully.',
                timer: 3000,
                timerProgressBar: true,
                position: 'bottom-end',
                showConfirmButton: false,
                toast: true
              });
            }
            else if (data.status === 'error') {
              Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: data.message,
                timer: 3000,
                timerProgressBar: true,
                position: 'bottom-end',
                showConfirmButton: false,
                toast: true
              });
            }
          },
          error: (xhr) => {

            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: xhr.responseJSON?.message || 'Position already assigned.',
              timer: 3000,
              timerProgressBar: true,
              position: 'bottom-end',
              showConfirmButton: false,
              toast: true
            });
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },


      fetch_Portal_admin() {
        const portal_id = this.$route.params.portal_id;
        const user_id = localStorage.getItem('user_id') || '';

        const payload = {
            portal_id: portal_id,
            user_id: user_id
        };

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_plartform_admin_api/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          success: (data) => {
            const details = data?.portal_admin_detalails || [];
            if (details.length > 0 && details[0]?.user?.is_active) {
              this.portal_admin_button = true;
            } else {
              this.portal_admin_button = false;
            }
          },
          error: () => {
            this.portal_admin_button = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },

get_member_id(user_id) {

  if (this.activeDropdown === user_id) {
    this.activeDropdown = null;
  } else {
    this.activeDropdown = user_id;
  }
},
handleClickOutside(event) {
  if (!event.target.closest('.reply_dropdown')) {
    this.activeDropdown = null;
  }
},

unassign_portal_admin(user_id) {
  const portal_id = this.$route.params.portal_id;
  const base_url = `${window.location.origin}${this.$route.path}`;

  const payload = {
    user_id: user_id,
    portal_id: portal_id,
    base_url: base_url
  };


  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/unassign_plartform_admin_api/`,
    method: 'POST',
    data: JSON.stringify(payload),
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json',
    },
    success: (data) => {
      if (data.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'success!',
          text: data.message,
          timer: 3000,
          timerProgressBar: true,
          position: 'bottom-end',
          showConfirmButton: false,
          toast: true
        });
        this.fetch_all_Portal_admin()
      }
      else if (data.status === 'error') {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: data.message,
          timer: 3000,
          timerProgressBar: true,
          position: 'bottom-end',
          showConfirmButton: false,
          toast: true
        });
      }
    },
    error: (xhr) => {

      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: xhr.responseJSON?.message || 'Position already assigned.',
        timer: 3000,
        timerProgressBar: true,
        position: 'bottom-end',
        showConfirmButton: false,
        toast: true
      });
    },
    complete: () => {
      this.isLoading = false;
    },
  });
},

fetch_all_Portal_admin() {
  const portal_id = this.$route.params.portal_id;

  const payload = {
      portal_id: portal_id,
  };

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_plartform_admin_api/`,
    method: 'POST',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(payload),
    success: (data) => {
      const details = data?.portal_admin_detalails || [];
      this.adminUserIds = new Set(
        details
          .filter(d => d.user && d.user.id)
          .map(d => d.user.id)
      );
    },
    error: () => {
      this.adminUserIds = new Set();
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},

  }
}
